






























import { Component, Mixins } from 'vue-property-decorator';
import { SysConst as SC } from '@/trials/plugins/const';
import { sessionModule } from '@/trials/store/modules/session';
import ConfirmDialog from '@/trials/views/components/ConfirmDialog.vue';
import NotificationDialog from '@/trials/views/components/NotificationDialog.vue';
import ErrorDialog from '@/trials/views/components/ErrorDialog.vue';
import LocalizationMixin from '@/common/views/mixins/LocalizationMixin';
import ContentHeader from '@/common/views/components/ContentHeader.vue';
import ContentFooter from '@/common/views/components/ContentFooter.vue';

@Component({ components: { ContentHeader, ContentFooter, ConfirmDialog, NotificationDialog, ErrorDialog } })
export default class App extends Mixins(LocalizationMixin) {
    /*----------------------------------*
     * Data
     *-----------------------------------*/
    private SC: any = SC;
    private titleKey = 'trials.title';

    /*----------------------------------*
     * ライフサイクルフック
     *-----------------------------------*/
    async created() {
        // ページ読み込み時しか呼び出されない

        const currentUrl = new URL(location.href);

        // 同意ページからの遷移かチェック
        if (!this.isAgreed(currentUrl, document.referrer)) {
            location.href = `${currentUrl.origin}/trialTool/terms.html`;
            return;
        }

        // 同意ページからの遷移と判断し、同意済みとする
        sessionModule.SET_AGREED(true);

        // リロード時にROOTへ遷移させる
        if (this.$route.path != SC.Path.ROOT) {
            this.$router.replace(SC.Path.ROOT);
        }

        sessionModule.init();

        // API呼び出し用token取得
        await sessionModule.getToken();

        // 初期画面表示
        if (this.$route.path == SC.Path.ROOT) {
            this.$router.push(SC.Path.TRAIN_DATA_MENU);
        }
    }

    private isAgreed(currentUrl: URL, referrerStr): boolean {
        // 直接ページが呼び出されているか
        if (referrerStr == '') {
            // 同意ページへ遷移
            return false;
        }

        // 同一FQDNからの遷移で必要なパラメータがセットされているか
        const referrerUrl = new URL(referrerStr);
        const needQuery = currentUrl.searchParams.get('agree');
        if (currentUrl.origin != referrerUrl.origin || needQuery != 'yes') {
            // NGの場合、同意ページへ遷移
            return false;
        }

        return true;
    }
}
import './assets/css/style.sass';
